import React from 'react';
// Redux related
import { connect } from 'react-redux';
import type { Connector } from 'react-redux';
// Selectors
import * as selectors from '../selectors';
// Actions
import * as actions from '../actions';
// Common imports
import { scaleAndFormatPrice, ProgressiveImageLoader } from '../../common';
//Assets
import TrashCan from '../../images/trash-icon.svg';
// Styles
import './BarbecueLineItem.css';
// types
import type { Product } from '../../products';

type Props = {
  variant: Product,
  desiredQuantity: number,
  barbecueSelectedVariants: Array<Product>,
  onRemove: () => void,
  toggleBarbecueCreated: (param: { barbecueCreated?: boolean }) => void,
};

const BarbecueLineItem = ({ variant, desiredQuantity, barbecueSelectedVariants, onRemove, toggleBarbecueCreated }: Props) => {
  return (
    <div className="barbecue-line-item-container">
      <div className="barbecue-line-item-content">
        <div className="product-image">
          <ProgressiveImageLoader
            selectedImage={variant.images[0]}
            imageToShow={'product'}
          />
        </div>
        <div className="product-info">
          <div className="product-name text center">{variant.name}</div>
          <div className="product-manufacturer text center">
            {variant.manufacturer}
          </div>
        </div>
        <div className="product-price text">
          {`${scaleAndFormatPrice(variant.price, variant.unitForQuantity)}`}
        </div>
        <div className="product-quantity-container center">
          <div className="product-quantity text">
            {variant.unitForQuantity === 'g'
              ? (desiredQuantity / 1000).toLocaleString('pt-br', {
                  currency: 'BRL',
                }) + ' Kg'
              : desiredQuantity + ` ${variant.unitForQuantity}`}
          </div>
        </div>

        <div className="remove-container center">
           <button
            className="barbecue-line-item-delete-button"
            onClick={e => {
              e.stopPropagation();
              onRemove();
              if(barbecueSelectedVariants.length === 1){
                toggleBarbecueCreated({ barbecueCreated: false });
              }
            }}
          >
            <img src={TrashCan} alt="Remover sugestão"/>
          </button>
        </div>
        
      </div>
      <div className="barbecue-line-item-end-line"></div>
    </div>
  );
};
const mapStateToProps = (state, ownProps) => {
  return {
    desiredQuantity: selectors.barbecueSelectedVariantQuantity(
      state,
      ownProps.variant.id,
    ),
    barbecueSelectedVariants: selectors.barbecueSelectedVariantsSelector(state),
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onRemove: () => dispatch(actions.removeBarbecueSuggestion(ownProps.variant.id)),
    toggleBarbecueCreated: (param: { barbecueCreated?: boolean }) => {
      const payload = param ? { barbecueCreated: param.barbecueCreated } : undefined;
      
      dispatch(actions.toggleBarbecueCreated(payload));
    },
  };
};
const connector: Connector<{}, Props> = connect(
  mapStateToProps,
  mapDispatchToProps,
);
export default connector(BarbecueLineItem);
